import React, { useCallback, useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Typography,
    CircularProgress,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@material-ui/core';
import Layout from './Layout';
import LogoImage from '../logo and name.png';


export const Enquiry = () => {

    const [enquiryData, setEnquiryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('Unread');
    const [modalOpen, setModalOpen] = useState(false);
    const [enquiryStatuses, setEnquiryStatuses] = useState({});
    const [updatedEnquiryData, setUpdatedEnquiryData] = useState(null);
    const [individualEnquiryStatuses, setIndividualEnquiryStatuses] = useState({});
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedEnquiryToDelete, setSelectedEnquiryToDelete] = useState(null);

    const baseUrl = localStorage.getItem('environment') === "dev" || !localStorage.getItem('environment') ? "https://dev.phyfarm.com/" : "https://v3.api.phyfarm.com/";
    console.log(baseUrl, window.environment);


    const getEnquiry = useCallback(() => {

        setLoading(true);
        const apiUrl = baseUrl + 'api/mgmt/farmsInfo/listAll';
        const authToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

        const requestData = {

            pagination: {
                current_page: page + 1,
            }
        };

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then(data => {

                const statuses = {};
                const individualStatuses = {};
                data.data.farms_infos.forEach(enquiry => {
                    statuses[enquiry.id] = enquiry.status;
                    individualEnquiryStatuses[enquiry.id] = enquiry.status;
                });
                setTotalCount(data.data.total_count);
                setEnquiryData(data.data.farms_infos);
                setEnquiryStatuses(statuses);
                setIndividualEnquiryStatuses(individualStatuses);
                setLoading(false);

            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
            });
    }, [baseUrl, page]);

    const handleChangePage = useCallback((event, newPage) => {

        setPage(newPage);

    }, []);

    const handleChangeRowsPerPage = useCallback(event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }, []);

    useEffect(() => {
        getEnquiry();
    }, [getEnquiry, page]);

    const handleOpenModal = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setSelectedStatus(individualEnquiryStatuses[enquiry.id]);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleStatusChange = (event) => {
        const newStatus = event.target.value;
        setSelectedStatus(newStatus); // Store the selected status for updating later
    };


    const handleStatusUpdate = () => {
        console.log("this click works");

        // Update the individualEnquiryStatuses with the new status
        setIndividualEnquiryStatuses(prevStatuses => ({
            ...prevStatuses,
            [selectedEnquiry.id]: selectedStatus, // Use selectedStatus here
        }));

        // Make API call to update the status
        const apiUrl = baseUrl + 'api/mgmt/farmsInfo/updateStatus';
        const authToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

        const requestData = {
            id: selectedEnquiry.id,
            status: selectedStatus, // Use selectedStatus here
        };

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update status');
                }
                return response.json();
            })
            .then(data => {

                const updatedEnquiryIndex = enquiryData.findIndex(enquiry => enquiry.id === selectedEnquiry.id);
                const updatedEnquiryList = [...enquiryData];
                updatedEnquiryList[updatedEnquiryIndex].status = selectedStatus;
                setEnquiryData(updatedEnquiryList);
                setUpdatedEnquiryData(updatedEnquiryList[updatedEnquiryIndex]);
                setIndividualEnquiryStatuses(prevStatuses => ({
                    ...prevStatuses,
                    [selectedEnquiry.id]: selectedStatus,
                }));

                handleCloseModal();
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const deleteConfirmation = (enquiry) => {
        setDeleteConfirmationOpen(true);
        setSelectedEnquiryToDelete(enquiry);
    };


    const handleDeleteEnquiry = () => {

        console.log("click works")

        const enquiry = selectedEnquiryToDelete;
        console.log(enquiry)

        setDeleteConfirmationOpen(false);
        setDeleteLoading(true);

        const apiUrl = baseUrl + 'api/mgmt/farmsInfo/delete';
        const authToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

        const requestData = {
            id: enquiry.id,
        };

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Delete enquiry response:', data);

                console.log('Enquiry entry deleted successfully')
                // Payment entry was deleted successfully, update the table data
                const updatedEnquiryList = enquiryData.filter(item => item.id !== enquiry.id);
                console.log('updatedPaymentList', updatedEnquiryList);
                setEnquiryData(updatedEnquiryList);


                getEnquiry();

                console.log('Delete payment response:', data);
                setDeleteLoading(false);

            })
            .catch(error => {
                console.error('Error deleting payment:', error);
                // Handle error if necessary
                setDeleteLoading(false);
            });
    }

    return (
        <Layout>
            <div className="App" style={{ marginTop: 100 }}>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={LogoImage} alt="Logo" style={{ width: '130px', marginLeft: 120 }} />
                </div>
                <Typography variant="h5" style={{ marginBottom: 20 }}>Enquiry</Typography>


                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage} // Remove the getEnquiry() call from here
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    labelDisplayedRows={({ from, to, count }) => `Navigate to Next Page: ${from}-${to} of ${count}`}
                />

                {loading ? (
                    <div style={{ textAlign: 'center', marginBottom: 20 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center' style={{ fontWeight: 'bold' }}>Crop Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Farm Area</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Phone Number</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Email</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>City</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>State</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Country</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Created At</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Intelligence Module</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Rating</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Status</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Array.isArray(enquiryData) && enquiryData.length > 0
                                        ? enquiryData.map((item, index) => (

                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}

                                                style={{ height: 90, cursor: 'pointer' }}
                                            >
                                                <TableCell align="center" component="td" scope="row">{item.crop_name}</TableCell>
                                                <TableCell align="center" component="td" scope="row" style={{ width: 200 }}>{item.farm_area}</TableCell>
                                                <TableCell align="center" component="td" scope="row" style={{ width: 200 }}>{item.name}</TableCell>
                                                <TableCell align="center">{item.phone}</TableCell>
                                                <TableCell align="center">{item.email}</TableCell>
                                                <TableCell align="center">{item.city}</TableCell>
                                                <TableCell align="center">{item.state}</TableCell>
                                                <TableCell align="center">{item.country}</TableCell>
                                                <TableCell align="center">{item.created_at}</TableCell>
                                                <TableCell align="center">{item.intelligence_module.join(', ')}</TableCell>
                                                <TableCell align="center">{item.rating}</TableCell>
                                                <TableCell align="center" onClick={() => handleOpenModal(item)}>
                                                    <span
                                                        style={{
                                                            color:
                                                                item.status === 'unread'
                                                                    ? 'red'
                                                                    : item.status === 'in-progress'
                                                                        ? 'blue'
                                                                        : item.status === 'completed'
                                                                            ? 'green'
                                                                            : 'inherit', // Default text color
                                                        }}
                                                    >
                                                        {item.status}
                                                    </span>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Button
                                                        aria-label="delete"
                                                        onClick={() => deleteConfirmation(item)}
                                                        color="secondary"
                                                        variant='outlined'
                                                    > DELETE
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        : (
                                            <TableRow>
                                                <TableCell align="center" colSpan={6}>
                                                    {
                                                        enquiryData && enquiryData.length === 0 ? (
                                                            <Typography variant="subtitle1">
                                                                No data available.
                                                            </Typography>
                                                        ) : null
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                }
                            </TableBody>

                        </Table>
                    </TableContainer>
                )}
            </div>

            <Dialog open={modalOpen} onClose={handleCloseModal} disableEnforceFocus>
                <DialogTitle>Enquiry Details</DialogTitle>
                <DialogContent sx={{ width: '800px' }}>
                    {selectedEnquiry && (
                        <div>
                            <Typography>Name: {selectedEnquiry.name}</Typography>
                            <Typography>Farm Area: {selectedEnquiry.farm_area}</Typography>
                            <Typography>Crop Name: {selectedEnquiry.crop_name}</Typography>
                            <Typography>Issues: {selectedEnquiry.intelligence_module.join(', ')}</Typography>
                            <FormControl style={{ marginTop: 10, width: 400, textAlign: 'center' }}>
                                <InputLabel>Status</InputLabel>
                                <Select value={selectedStatus} style={{ marginTop: 20 }} onChange={handleStatusChange}>
                                    <MenuItem value="unread" >Unread</MenuItem>
                                    <MenuItem value="in-progress">In Progress</MenuItem>
                                    <MenuItem value="completed" >Done</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModal} variant="contained" color="secondary">
                        Close
                    </Button>
                    <Button variant="contained" onClick={handleStatusUpdate} color="primary" >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)} disableEnforceFocus>
                <DialogTitle>Delete Enquiry</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this enquiry?
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setDeleteConfirmationOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button variant="outlined" onClick={handleDeleteEnquiry} color="secondary" >
                        {deleteLoading ? <CircularProgress size={24} /> : 'Delete'}
                        {/* {console.log(deleteLoading)}
                        DELETE */}
                    </Button>
                </DialogActions>
            </Dialog>
        </Layout>
    );
};

